export default "__VITE_ASSET__myeFd_VJ__"